import React from 'react'
import { t } from 'ttag'
import cx from 'classnames'
import styles from './Card.module.scss'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { Icon, CheckCircleIcon } from 'components/shared/Icon/Icon'
import ClockIcon from 'assets/icons/grey-clock.svg'

type CardProps = {
  image: string
  name: string
  description: string
  handleReuse?: () => void
  onClick: () => void
  isOptional?: boolean
  completed?: boolean
  buttonLabel?: string
  hideButton?: boolean
  showReuseButton?: boolean
}

export const Card = ({
  image,
  name,
  description,
  handleReuse,
  onClick,
  isOptional,
  completed,
  buttonLabel,
  hideButton,
  showReuseButton,
}: CardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.title}>
        <img src={image} alt={t`${name} icon`} /> {name}{' '}
        {completed ? (
          <Icon size={14} icon={CheckCircleIcon} className={styles.icon} />
        ) : isOptional ? (
          <span className={styles.optional}>{t`Optional`}</span>
        ) : null}
      </div>
      <div className={styles.description}>{description}</div>
      <div className={styles.time}>
        <img src={ClockIcon} alt={t`Estimated time`} />
        <span>~20 min</span>
      </div>
      <div
        className={cx(styles.button, {
          [styles.hide]: Boolean(hideButton),
        })}
      >
        <BoldButton
          label={buttonLabel}
          isPrimary={!completed}
          width="130px"
          onClick={onClick}
        />
        {showReuseButton && (
          <BoldButton
            label={t`Reuse results`}
            isPrimary={false}
            width="156px"
            onClick={handleReuse}
            className={styles.reuseButton}
          />
        )}
      </div>
    </div>
  )
}
